<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      title="详情 线下支付"
      id-key="OfflinePayId"
      :data="data"
      :save-func="() => {}"
      @edit-opened="onEditOpened"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称">
              <span>{{ data.CustomerName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型">
              <span v-if="data.UseTo == 0">储值卡充值</span>
              <span v-else>还款</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="流水号">
              <span>{{ data.PayNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="金额">
              <span>{{ data.PayAmount }}</span>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="图片">
              <el-image :src="'/api'+data.PicUrl" :preview-src-list="['/api'+data.PicUrl]"></el-image>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="支付时间">
              <span>{{ this.$commonJs.toDateString(data.PayTime) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <span>{{ data.Remark }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button
          size="mini"
          type="success"
          @click="review(1)"
          v-if="data.Status != 1 && data.Status != 2"
          >通 过</el-button
        >
        <el-button
          size="mini"
          type="danger"
          @click="review(2)"
          v-if="data.Status != 1 && data.Status != 2"
          >不通过</el-button
        >
        <el-button size="mini" @click="close">取 消</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [detailsDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        CustomerName:"",
        OfflinePayId: 0,
        CustomerId: 0,
        CustomerType: 0,
        UseTo: 0,
        PayNo: "",
        PayAmount: 0,
        PayTime: null,
        PicUrl: "",
        Status: 0,
        Remark: "",
      },
      api: require("@/api/sy/offlinePay").default,
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {},
    review(status) {
      this.$refs.dialog.$refs.form
        .validate()
        .then((valid) => {
          if (!valid) return;
          this.data.Status = status;
          this.$refs.dialog.isLoading = true;
          this.api.review(this.data).then((res) => {
            this.$refs.dialog.isLoading = false;
            if (res.Code == 0) this.$message.success("审核成功"),this.$emit("close-saved");
            else this.$message.error("审核失败");
          });
        })
        .catch(() => {});
    },
  },
};
</script>
